import { useEffect } from "react";
import { useContent } from "../hooks/useContent";
import { Fade } from "react-reveal";
import { GoGoal } from "react-icons/go";
import { GiCandlebright } from "react-icons/gi";
import { BiLogoTelegram } from "react-icons/bi";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Header from "../components/shared/Header";
import Footer from "../components/shared/Footer";
const Vision = () => {
  // ----------- hooks ------------
 
  return (
    <>
    <Header subtitle={"Our philosophy"} pagetitle={"About arcelia"}/>
   <Content />
    <Footer />
    </>
  );
};

export const Content = () => {
  
  
  const { t, i18n } = useTranslation();
  const { vision, fetchVision } = useContent();

  useEffect(() => {
    (async () => {

      const getData = await fetchVision();
    })();
  }, [i18n.language]);
  return(
    <div style={{direction: i18n.language === 'ar' ? 'rtl': 'ltr'}}>
    <div className="md:w-4/6 py-20 px-5 mx-auto">
      <div className="py-10 flex flex-col md:flex-row items-center gap-20">
        <Fade right>
          <div className="vision-img z-10 relative md:w-96 w-72 rounded-xl">
            <img
              className=" rounded-2xl h-64 w-96 object-cover"
              src={vision.philosophy_image ?? require("../assets/news3.jpg")}
              alt="صورة رؤية ارسيليا"
            />
          </div>
        </Fade>
        <Fade left>
          <div className="md:w-1/2 flex flex-col gap-5">
            <h1 className="font-semibold text-2xl text-purple">
              {vision.philosophy_title}
            </h1>
            <p className="text-lg font-medium">{vision.philosophy_content}</p>
           
          <button
            className={`bg-gray bg-purple hover:bg-indigo-950 text-white py-2 w-[60px] rounded-md `}
          
          
          >
            <Link to="/vision">
            
            {t("More")}
            </Link>
          </button>
          </div>
        </Fade>
      </div>
    </div>
    <div className="py-20 md:px-60 text-lg font-medium bg-bgGray">
      <div className="relative">
        <Fade top>
          <div className="flex flex-col gap-5 m-4">
            <h1 className="font-semibold text-2xl text-purple">
              {vision.philosophy_sub_title}
            </h1>
            <p className="text-lg font-medium">
              {vision.philosophy_sub_content}
            </p>
            <p className="font-semibold text-md text-white p-2 w-40 text-center rounded-lg bg-purple cursor-pointer">
              <Link to="/projects">{t("Company projects")}</Link>
            </p>
          </div>
        </Fade>
        <Fade top>
          <div className=" flex flex-col md:flex-row gap-10 justify-between m-5 items-strech">
            <div className="bg-white p-10 rounded-xl w-2/3">
              <BiLogoTelegram fontSize={"40px"} color="#ADADAD" />
              <h1 className="font-semibold text-xl text-purple">
                {t("Our message")}
              </h1>
              <p className="text-md font-medium">
                {vision.philosophy_message}
              </p>
            </div>
            <div className="bg-white p-10 rounded-xl w-2/3">
              <GiCandlebright fontSize={"40px"} color="#ADADAD" />
              <h1 className="font-semibold text-xl text-purple">
                {t("Our Values")}
              </h1>
              <p className="text-md font-medium">{vision.philosophy_value}</p>
            </div>
            <div className="bg-white p-10 rounded-xl w-2/3">
              <GoGoal fontSize={"40px"} color="#ADADAD" />
              <h1 className="font-semibold text-xl text-purple">
                {t("Our Goal")}
              </h1>
              <p className="text-md font-medium">{vision.philosophy_goal}</p>
            </div>
          </div>
        </Fade>
      </div>
    </div>
  </div>
);

}
export default Vision;
